import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="task-assignee"
// Handles combined Team/User selection for task assignment
export default class extends Controller {
  static targets = ["input", "dropdown", "assignedToField", "teamField", "option"]

  connect() {
    // Close dropdown when clicking outside
    this.boundCloseDropdown = this.closeDropdown.bind(this)
    document.addEventListener('click', this.boundCloseDropdown)
  }

  disconnect() {
    document.removeEventListener('click', this.boundCloseDropdown)
  }

  toggleDropdown(event) {
    event.stopPropagation()
    this.dropdownTarget.classList.toggle('hidden')
    if (!this.dropdownTarget.classList.contains('hidden')) {
      this.inputTarget.focus()
    }
  }

  closeDropdown(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.classList.add('hidden')
      this.clearSearch()
    }
  }

  preventClose(event) {
    event.stopPropagation()
  }

  search(event) {
    const query = event.target.value.toLowerCase()

    this.optionTargets.forEach(option => {
      const text = option.textContent.toLowerCase()
      const group = option.closest('[data-group]')

      if (text.includes(query)) {
        option.classList.remove('hidden')
        if (group) group.classList.remove('hidden')
      } else {
        option.classList.add('hidden')
      }
    })

    // Hide groups if all their options are hidden
    const groups = this.element.querySelectorAll('[data-group]')
    groups.forEach(group => {
      const visibleOptions = group.querySelectorAll('[data-task-assignee-target="option"]:not(.hidden)')
      if (visibleOptions.length === 0) {
        group.classList.add('hidden')
      }
    })
  }

  select(event) {
    event.preventDefault()
    const option = event.currentTarget
    const type = option.dataset.type
    const id = option.dataset.id
    const text = option.dataset.text

    // Update hidden fields based on type
    if (type === 'Team') {
      this.teamFieldTarget.value = id
      this.assignedToFieldTarget.value = ''
    } else if (type === 'User') {
      this.assignedToFieldTarget.value = id
      this.teamFieldTarget.value = ''
    }

    // Update the display button
    const displayButton = this.element.querySelector('[data-action*="toggleDropdown"]')
    const displayText = displayButton.querySelector('.selected-text')
    if (displayText) {
      displayText.textContent = text
      displayText.style.color = '#111827'
    }

    this.dropdownTarget.classList.add('hidden')
    this.clearSearch()
  }

  clear(event) {
    event.preventDefault()
    event.stopPropagation()

    this.assignedToFieldTarget.value = ''
    this.teamFieldTarget.value = ''

    // Update the display button
    const displayButton = this.element.querySelector('[data-action*="toggleDropdown"]')
    const displayText = displayButton.querySelector('.selected-text')
    if (displayText) {
      displayText.textContent = t('javascript.controllers.task_assignee_controller.unassigned')
      displayText.style.color = '#6b7280'
    }

    this.dropdownTarget.classList.add('hidden')
    this.clearSearch()
  }

  clearSearch() {
    this.inputTarget.value = ''
    this.optionTargets.forEach(option => option.classList.remove('hidden'))
    const groups = this.element.querySelectorAll('[data-group]')
    groups.forEach(group => group.classList.remove('hidden'))
  }
}

